import React, { memo, useState, useEffect, useCallback } from "react";
import styled from "styled-components";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { gateway } from "../../../../utils/api";
import ModalWarningView from "../../../Modals/ModalWarningView";
import { openCallToAction } from '../../../../business/cta';


  const StyleNovidades = styled.div`
    margin-left: -15px;
    width: 102%;
    padding: 10px 10px 10px 20px;
  `;
  const ArrowButton = styled.button`
  background-color: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  color: #333;
  font-size: 18px;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 5;
  display: flex;
  align-items: center;
  opacity: 0.8; /* Adiciona opacidade para destaque */
  justify-content: center;
  ${(props) => (props.left ? "left: 10px;" : "right: 10px;")}

  &:hover {
    background-color: #e0e0e0;
  }
`;

const CustomLeftArrow = ({ onClick }) => (
  <ArrowButton left onClick={onClick}>
    &#10094;
  </ArrowButton>
);

const CustomRightArrow = ({ onClick, hasNextPage, loadingMore, onLoadMore }) => (
  <ArrowButton 
    onClick={() => {
      // Se há mais páginas e não está carregando, carrega mais dados
      if (hasNextPage && !loadingMore) {
        onLoadMore();
      }
      // Sempre permite a navegação normal do carousel
      if (onClick) onClick();
    }}
  >
    &#10095;
  </ArrowButton>
);

  const HeaderContainer = styled.div`
    background: 
      linear-gradient(0deg, #4CC9FF, #4CC9FF),
      url('https://i.imgur.com/2UIJiCi.png') no-repeat;
    background-blend-mode: overlay;
    background-size: 30% 30%, 45%; 
    background-position: -80%, right 10% bottom 30px; 
    padding: 20px;
    color: #fff;
    position: relative;
    z-index: 1;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 133, 199, 0.8); 
      z-index: -1;
    }
  `;

  const TitleSection = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    margin-top: 20px;
  `;

  const TitleImage = styled.img`
    width: 400px;
    height: 240px;
    margin-right: 20px;
    margin-left: 40px;
    border-radius: 8px;
    border: 2px solid #FFFFFF;
    object-fit: cover;
  `;

  const Title = styled.h1`
    font-size: 48px;
    margin: 0;
  `;


  const AvisosSection = styled.div`
    margin-top: 20px;
    margin-left: 40px;
  `;

  const AvisoContainer = styled.div`
    position: relative; 
    display: flex;
    flex-direction: column;
    padding: 15px;
    background-color: #FFFFFF;
    color: #3B3B3B;   
    border-radius: 8px;
    margin-right: 10px;
    max-width: 350px;
    min-width: 320px;
    height: 200px;
    box-sizing: border-box;
  `;

  const AvisoTexto = styled.div`
    font-size: 14px;
    color: #000000;
    font-weight: bold;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 1.3;
    flex: 1;
    margin-left: 10px;
  `;

  const DateTexto = styled.div`
    font-size: 10px;
    color: #3B3B3B;
  `;

  const AvisoDescription = styled.div`
    font-size: 12px;
    color: #3B3B3B;
    margin-top: 5px;
    overflow: hidden;
    height: 80px;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    flex: 1;
  `;

  const VerMaisButton = styled.button`
    background-color: #ffcc00;
    border: none;
    border-radius: 5px;
    padding: 5px 10px;
    cursor: pointer;
    font-size: 12px;
    color: #000;
  `;

  const Tabs = styled.div`
    display: flex;
    margin-top: 20px;
    margin-left: 40px;
  `;

  const Tab = styled.div`
    padding: 10px 20px;
    cursor: pointer;
    color: #fff;
    font-size: 16px;
    font-weight: ${(props) => (props.active ? "bold" : "normal")};
    border-bottom: ${(props) => (props.active ? "2px solid #fff" : "none")};
  `;

  const MoreContent = styled.div`
    position: absolute;
    bottom: 15px;
    left: 15px;
    right: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #FFFFFF;
    padding-top: 5px;
  `;

  const AvisoHeader = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    height: 50px;
    flex-shrink: 0;
  `;

  const AvisoImage = styled.img`
    width: 40px;
    height: 40px;
    border-radius: 50%; 
    margin-right: 10px; 
    border: 1px solid #ccc; 
  `;

  const AvisosHeader = styled.div`
    display: flex;
    align-items: center;
    font-size: 24px;
    font-weight: bold;
    color: #FFFFFF;
    margin-bottom: 10px;
    padding-bottom: 5px;
    border-bottom: 2px solid #646464;
  `;

  const AvisosCount = styled.span`
    font-size: 18px;
    color: #D3D3D3;
    margin-left: 8px;
  `;

  const AvisosTitle = styled.h2`
    margin: 0;
    font-size: 26px;
    color: #FFFFFF;
  `;

  const responsive = {
    veryDesktop: {
      breakpoint: { max: 3000, min: 1560 },
      items: 5,
      slidesToSlide: 1,
    },
    largDesktop: {
      breakpoint: { max: 1560, min: 1385 },
      items: 4,
      slidesToSlide: 1,
    },
    desktop: {
      breakpoint: { max: 1385, min: 1024 },
      items: 3,
      slidesToSlide: 1, 
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  const Header = ({ turma, activePage, selectPage }) => {
    const [warningIndex, setWarningIndex] = useState(0)
    const [responseWarningsData, setResponseWarningsData] = useState();
    const [element, setElement] = useState({})
    const [openModalWarn, setOpenModalWarn] = useState(false)
    const [currentPage, setCurrentPage] = useState(1);
    const [hasNextPage, setHasNextPage] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [carouselKey, setCarouselKey] = useState(0);
    const [loadingWarnings, setLoadingWarnings] = useState(false);
    const onOpenModalWarn = () => setOpenModalWarn(true)
    const onCloseModalWarn = () => setOpenModalWarn(false);

    const tabs = [
      { label: "Feed da turma", page: "HOME" },
      { label: "Notas e Faltas", page: "GRANDESANDABSENCES" },
    ];

    function removeHtmlTagsAndLimit(htmlString, limit = 200) {
      const textOnly = htmlString.replace(/<\/?[^>]+(>|$)/g, '').replace(/&nbsp;/g, ' ').trim();
      return textOnly.length > limit ? `${textOnly.substring(0, limit)}...` : textOnly;
    }
    const handleCallToAction = useCallback(cta => {
      const keys = Object.keys(cta);
      const values = Object.values(cta);
      const obj = {
        key: keys[0],
        value: values[0]
      };
      openCallToAction(obj);
    }, []);

    async function loadWarnings(code, page = 1) {
      try {
        if (page === 1) {
          setLoadingWarnings(true);
        } else {
          setLoadingMore(true);
        }
        const url = `webbff/lit_app_web/classes/${code}/warnings?page=${page}`;
        const response = await gateway.get(url);
        return response;
      } catch (error) {
        console.error(error);
      } finally {
        if (page === 1) {
          setLoadingWarnings(false);
        } else {
          setLoadingMore(false);
        }
      }
    }
    
    async function loadWarningsAll(code) {
      const warnings = await loadWarnings(code, 1);
      if (warnings) {
        setResponseWarningsData(warnings);
        setCurrentPage(1);
        setHasNextPage(warnings.hasNextPage);
      }
    }

    async function loadMoreWarnings(code) {
      if (!hasNextPage || loadingMore) return;
      
      const nextPage = currentPage + 1;
      const warnings = await loadWarnings(code, nextPage);
      
      if (warnings) {
        setResponseWarningsData(prevData => {
          const newData = {
            ...prevData, // Mantém os metadados originais (totalDocs, etc.)
            docs: [...prevData.docs, ...warnings.docs], // Concatena apenas os docs
            hasNextPage: warnings.hasNextPage, // Atualiza apenas o hasNextPage
            page: warnings.page // Atualiza a página atual
          };
          
          return newData;
        });
        setCurrentPage(nextPage);
        setHasNextPage(warnings.hasNextPage);
      }
    }

    useEffect(() => {
      if (turma) {
        // Resetar todos os estados quando turma mudar
        setResponseWarningsData(null);
        setCurrentPage(1);
        setHasNextPage(false);
        setLoadingMore(false);
        setCarouselKey(prev => prev + 1); // Força re-criação do carousel
        loadWarningsAll(turma.organizationCode);
      }
    }, [turma]);

    const openModalWarning = (el, index) => {
      setWarningIndex(index)
      setElement(el);
      onOpenModalWarn();
    }
    
    const fallbackUrl = "https://api.lit.com.br/api/media/file/download/672a1362e96a440012050f42.jpg";
    const fallbackName = "Sem Título";
    
    // Criar array com todos os itens (carregados + placeholders)
    const getAllItems = () => {
      if (!responseWarningsData) return [];
      
      const totalItems = responseWarningsData.totalDocs;
      const loadedItems = responseWarningsData.docs;
      const allItems = [];
      
      // Adicionar todos os itens carregados
      loadedItems.forEach((item, index) => {
        allItems[index] = item;
      });
      
      // Adicionar placeholders para itens não carregados
      for (let i = loadedItems.length; i < totalItems; i++) {
        allItems[i] = {
          id: `placeholder-${i}`,
          name: `Carregando item ${i + 1}...`,
          message: 'Carregando...',
          time: 'Carregando...',
          isPlaceholder: true
        };
      }
      
      return allItems;
    };
    
    return (
      <HeaderContainer>
        <TitleSection>
          <TitleImage
            src={turma.cover || fallbackUrl}
            alt="Curso"
            onError={(e) => { e.currentTarget.src = fallbackUrl; }}
          />
          <div>
            <Title>{turma.name || fallbackName}</Title>
          </div>
        </TitleSection>
{responseWarningsData &&         
      <AvisosSection>
          <AvisosHeader>
            <AvisosTitle>Avisos</AvisosTitle>
            <AvisosCount>({responseWarningsData && responseWarningsData.totalDocs})</AvisosCount>
          </AvisosHeader>
          {loadingWarnings && (
            <div style={{ color: '#FFFFFF', textAlign: 'center', padding: '20px' }}>
              Carregando avisos...
            </div>
          )}
          {!loadingWarnings && responseWarningsData && responseWarningsData.docs && responseWarningsData.docs.length > 0 && (
            <StyleNovidades>
              <Carousel
                key={`carousel-${carouselKey}-${turma && turma.organizationCode ? turma.organizationCode : 'default'}`}
                responsive={responsive}
                swipeable
                draggable
                showDots={false}
                keyBoardControl
                customTransition="all 0.5s"
                transitionDuration={500}
                containerClass="carousel-container"
                itemClass="carousel-item-padding-10-px"
                customLeftArrow={<CustomLeftArrow />}
                customRightArrow={
                  <CustomRightArrow 
                    hasNextPage={hasNextPage}
                    loadingMore={loadingMore}
                    onLoadMore={() => loadMoreWarnings(turma.organizationCode)}
                  />
                }
                removeArrowOnDeviceType={["tablet", "mobile"]}
                partialVisbile={false}
                centerMode={false}
                autoPlay={false}
                shouldResetAutoplay={false}
                additionalTransfrom={0}
                rewind={false}
                rewindWithAnimation={false}
                rtl={false}
                focusOnSelect={false}
                minimumTouchDrag={80}
              >
                {getAllItems().map((item, index) => (
                  <div key={item.id || index}>
                    <AvisoContainer key={item.id || index}>
                      <AvisoHeader>
                        <AvisoImage src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQmvzijAToD4vUbylmjog2tmsATm6l7UkdgDA&s" alt="Ícone do Aviso" />
                        <AvisoTexto>{item.name}</AvisoTexto>
                      </AvisoHeader>
                      <AvisoDescription>{removeHtmlTagsAndLimit(item.message || '')}</AvisoDescription>
                      <MoreContent>
                        <DateTexto>{item.time}</DateTexto>
                        {!item.isPlaceholder && (
                          <VerMaisButton onClick={() => openModalWarning(item, index)}> Ver mais</VerMaisButton>
                        )}
                      </MoreContent>

                    </AvisoContainer>
                  </div>
                  
                ))}
                  <ModalWarningView 
                      openModal={openModalWarn}
                      onCloseModal={onCloseModalWarn}
                      onClick={() => handleCallToAction(responseWarningsData.docs[warningIndex])}
                      element={element}
                      onOrganization={false}
                      />
              </Carousel>
            </StyleNovidades>
          )}
          {!loadingWarnings && (!responseWarningsData || !responseWarningsData.docs || responseWarningsData.docs.length === 0) && (
            <div style={{ color: '#FFFFFF', textAlign: 'center', padding: '20px' }}>
              Nenhum aviso disponível
            </div>
          )}
        </AvisosSection>}


        <Tabs>
          {tabs.map((tab) => (
            <Tab key={tab.page} active={activePage === tab.page} onClick={() => selectPage(tab.page)}>
              {tab.label}
            </Tab>
          ))}
        </Tabs>


      </HeaderContainer>
    );
  };

  export default memo(Header);
